<!--
 * @Author: ext.shuiqianning1
 * @Date: 2022-06-06 18:06:44
 * @LastEditors: ext.shuiqianning1
 * @LastEditTime: 2022-06-21 12:28:36
 * @FilePath: /content-center/src/components/wiki/ProjectEffectiveness.vue
-->
<template>
  <div class="content-item flex align-items-center">
    <div class="content-item-label">
      <span class="red" v-if="JSON.parse(commonData[1].value) === '1'">*</span
      >{{ JSON.parse(commonData[2].value) || "项目功效" }}
    </div>
    <div class="keyword-list">
      <el-tag
        size="mini"
        :key="item"
        v-for="item in keywordInfos"
        closable
        :disable-transitions="false"
        style="margin-left: 10px"
        @close="closeTag(item)"
        >{{ item }}
      </el-tag>
      <el-input
        class="input-keyword"
        v-model="inputValue"
        ref="saveTagInput"
        size="mini"
        :maxlength="JSON.parse(commonData[0].value)"
        @keyup.enter.native="getKeyword"
        placeholder="输入项目功效后，回车确定；关键词可输入多个"
      ></el-input>
    </div>
  </div>
</template>

<script>
export default {
  name: "Keywords",
  props: ["projectEffectivenessShow", "commonData"],
  data() {
    return {
      inputValue: "",
      keywordInfos: [],
    };
  },
  methods: {
    closeTag(item) {
      this.keywordInfos.splice(this.keywordInfos.indexOf(item), 1);
    },
    getKeyword() {
      let isPush = this.keywordInfos.some((item) => item == this.inputValue);
      if (!isPush) {
        this.keywordInfos.push(this.inputValue);
        if (
          this.keywordInfos.length >
          Number(JSON.parse(this.commonData[0].value))
        ) {
          this.keywordInfos.pop();
          this.inputValue = "";
          this.$message.error("最多20个关键词");
          return false;
        }
      }
      this.inputValue = "";
    },
  },
};
</script>

<style lang="scss" scoped>
//关键词
.keyword-list {
  width: 645px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  .el-tag {
    margin-top: 5px;
    background-color: #f4f4f5;
    border-color: #e9e9eb;
    color: #909399;

    .el-tag__close {
      color: #909399;

      &:hover {
        background-color: #f4f4f5;
      }
    }
  }

  .input-keyword {
    border: none;
    flex-shrink: 0;
    width: 415px !important;

    :deep(.el-input__inner) {
      border: none !important;
      line-height: 26px;
      height: 26px;
    }
  }
}
</style>
